export default function BrandStory() {
  return (
    <section id="brand-story" className="py-16 lg:py-24 bg-gradient-to-b from-white to-[#f8f9fc]">
      <div className="max-w-7xl mx-auto px-6 lg:px-32">
        <div className="text-center mb-12 lg:mb-16">
          <h2 className="text-2xl lg:text-4xl font-light text-gray-800 mb-4 lg:mb-6">
            品牌故事
          </h2>
          <div className="w-20 h-1 bg-gradient-to-r from-[#847eba] to-[#a3c1c3] mx-auto"></div>
        </div>

        <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-center mb-16 lg:mb-24">
          <div className="space-y-6 lg:space-y-8">
            <h3 className="text-lg lg:text-xl font-medium text-gray-800">
              从实验室到生活的温暖陪伴
            </h3>
            <p className="text-xs lg:text-base text-gray-600 font-light leading-relaxed">
              燃轻元诞生于北京燃轻元医疗技术研究院的实验室，但我们想做的，不止于科学。我们深知，体重管理的路上，最大的敌人不是脂肪，而是焦虑和自我怀疑。
            </p>
            <p className="text-xs lg:text-base text-gray-600 font-light leading-relaxed">
              因此，我们创造了瘦瘦哈乐猴IP形象——它不是一个严厉的教练，而是一个懂你的朋友。我们相信，真正的改变，源于一种轻松的心态。当你放下对数字的执念，开始享受这个过程时，轻盈的身体自然会随之而来。
            </p>
          </div>
          
          <div className="relative">
            <div className="absolute inset-0 bg-gradient-to-br from-[#847eba]/5 to-[#a3c1c3]/5 rounded-3xl transform rotate-6"></div>
            <img 
              src="https://static.readdy.ai/image/2e1ac11483faca2c19cd44d7d582b015/4fec4f384215bc5652e7cf8606508c09.png"
              alt="品牌故事"
              className="relative z-10 w-full h-64 lg:h-80 object-cover rounded-3xl shadow-lg"
            />
          </div>
        </div>

        <div className="bg-gradient-to-br from-[#847eba]/5 to-[#a3c1c3]/5 rounded-3xl p-8 lg:p-12">
          <div className="text-center max-w-4xl mx-auto">
            <h3 className="text-lg lg:text-xl font-medium text-gray-800 mb-6 lg:mb-8">
              我们的初心
            </h3>
            <div className="grid md:grid-cols-2 gap-6 lg:gap-8 text-left">
              <div className="space-y-4">
                <div className="flex items-start gap-3">
                  <div className="w-2 h-2 bg-[#847eba] rounded-full mt-2 flex-shrink-0"></div>
                  <p className="text-xs lg:text-base text-gray-600 font-light leading-relaxed">
                    不贩卖身材焦虑，而是倡导身心快乐
                  </p>
                </div>
                <div className="flex items-start gap-3">
                  <div className="w-2 h-2 bg-[#847eba] rounded-full mt-2 flex-shrink-0"></div>
                  <p className="text-xs lg:text-base text-gray-600 font-light leading-relaxed">
                    不追求快速结果，而是赋能轻松过程
                  </p>
                </div>
              </div>
              <div className="space-y-4">
                <div className="flex items-start gap-3">
                  <div className="w-2 h-2 bg-[#a3c1c3] rounded-full mt-2 flex-shrink-0"></div>
                  <p className="text-xs lg:text-base text-gray-600 font-light leading-relaxed">
                    让科学可持续的体重管理成为日常
                  </p>
                </div>
                <div className="flex items-start gap-3">
                  <div className="w-2 h-2 bg-[#a3c1c3] rounded-full mt-2 flex-shrink-0"></div>
                  <p className="text-xs lg:text-base text-gray-600 font-light leading-relaxed">
                    用温暖陪伴替代严厉督促
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}